import { mutationOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import { getBaseTaskListQueryKey } from '../task/api';
import type { VideoReplicationTaskDto } from '../task/model';
import type { VideoReplicationInputDto } from './model';

export const replicateVideo = mutationOptions({
  mutationKey: [...getBaseTaskListQueryKey()],
  mutationFn: async (input: VideoReplicationInputDto) => {
    return http
      .post('script/video/replication', {
        json: input,
      })
      .json<VideoReplicationTaskDto>();
  },
});
